import {objectResolver, resolveNumber} from 'airship/utils/resolvers'
import {Resolver} from 'airship/utils/resolvers/types'

export interface CreateTicketResponse {
  ticketNumber: number
}

export const resolveCreateTicketResponse: Resolver<CreateTicketResponse> = objectResolver(
  {
    ticketNumber: resolveNumber,
  }
)
